import { Button, Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';

const CardView = ({ data, isMultiSelectable, schema, currentSelectedBooking, setCurrentSelectedBooking, setCurrentActiveBookingAction }) => {
  const history = useHistory();

  const routeHandler = selectedBooking => {
    const params = {
      id: selectedBooking?.id,
    };
    history.push({
      pathname: selectedBooking?.configurationType === 'program_onboarding' ? '/v2/program-onboarding' : '/v2/vendor-onboarding',
      search: `?${queryString.stringify(params)}`,
    });
  };

  return (
    <div className="horizontal-scrollor">
      <div className="booking-data-card-container">
        {data?.map((result, index) => (
          <>
            <Card className={`booking-card ${currentSelectedBooking?.[0]?.id === result?.id ? 'active' : ''}`} key={index}>
              <CardHeader
                className="cursor-pointer d-flex align-items-center gap-2"
                onClick={() => setCurrentSelectedBooking([{ ...result }])}
                style={{ background: 'rgba(233, 235, 236, 1)' }}
              >
                <div
                  style={{
                    display: 'flex',
                    width: '20px',
                    height: '20px',
                    background: currentSelectedBooking?.[0]?.id === result?.id ? 'rgba(64, 81, 137, 1)' : 'rgba(191, 193, 206, 1)',
                    borderRadius: '2px',
                  }}
                >
                  <i className="ri-check-fill m-auto" style={{ color: 'white' }}></i>
                </div>
                <p className="m-0 fs-14 fw-medium" style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {result?.name || '' || result?.clientName || result?.vendorName || ''}
                </p>
              </CardHeader>

              <CardBody className="booking-card-body">
                <Row>
                  {schema?.map((cSchema, index) => {
                    const value = result?.[cSchema?.key];

                    let content = value || 'NA';

                    // Special rendering for status field
                    if (cSchema?.key === 'status') {
                      const status = value?.toLowerCase();
                      let statusClass = 'custom-status-badge-card ';

                      if (status === 'live' || status === 'active') statusClass += 'custom-status-live';
                      else if (status === 'pending') statusClass += 'custom-status-pending';
                      else if (status === 'rejected') statusClass += 'custom-status-rejected';
                      else if (status === 'draft') statusClass += 'custom-status-draft';
                      else if (status === 'approved') statusClass += 'custom-status-approved';
                      else if (status === 'published') statusClass += 'custom-status-published';

                      content = <span className={statusClass}>{value}</span>;
                    }

                    return (
                      <Col md={`${cSchema?.metadata?.widthPercentage === 50 ? 6 : 12}`} className="mb-3" key={index}>
                        <div className="booking-details-heading">{cSchema?.label || '-'}</div>
                        <div className="booking-details-data">{content}</div>
                      </Col>
                    );
                  })}
                </Row>

                <Row>
                  <Col md={12} className="text-center mt-3">
                    <div className="d-flex gap-2 flex-wrap justify-content-center">
                      <>
                        {[
                          { action: 'approve_airport', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'revoke_configuration', label: 'Revoke', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'reject_airport', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                          { action: 'approve_zone', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'reject_zone', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                          { action: 'approve_vendor', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'reject_vendor', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                          { action: 'approve_client', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'reject_client', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                          { action: 'approve_vendor_pricing', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'reject_vendor_pricing', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                          { action: 'approve_client_pricing', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'reject_client_pricing', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                          { action: 'approve_client_zone', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'reject_client_zone', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                          { action: 'publish_airport', label: 'Publish', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'publish_vendor', label: 'Publish', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'publish_client', label: 'Publish', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          { action: 'publish_zone', label: 'Publish', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          // { action: 'seek_approval', label: 'Seek Approval', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                        ].map(({ action, label, className, color }) =>
                          result?.actions?.includes(action) ? (
                            <Button
                              key={action}
                              className={className}
                              color={color}
                              onClick={() => {
                                setCurrentActiveBookingAction(action);
                                setCurrentSelectedBooking([{ ...result }]);
                              }}
                            >
                              {label}
                            </Button>
                          ) : null,
                        )}

                        {result?.actions?.includes('edit_configuration') && (
                          <Button
                            className="customized-btn d-flex align-items-center gap-1"
                            onClick={() => {
                              routeHandler(result);
                            }}
                            color="primary"
                          >
                            <i className="ri-edit-line"></i>
                            <span>Edit Configuration</span>
                          </Button>
                        )}

                        {result?.actions?.includes('publish_config') && (
                          <Button
                            className="customized-btn d-flex align-items-center gap-1"
                            onClick={() => {
                              setCurrentActiveBookingAction('publish_config');
                              setCurrentSelectedBooking([{ ...result }]);
                            }}
                            color="primary"
                          >
                            <span>Publish Config</span>
                          </Button>
                        )}
                      </>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </>
        ))}
      </div>
    </div>
  );
};

export default CardView;
